import {observer} from "mobx-react";
import * as React from "react";
import {observable} from "mobx";
import {UserAnswer} from "components/quiz/UserAnswer";
import {QuizQuestion} from "components/quiz/QuizQuestion";
import {Range} from "react-range";

interface IRangeSelectorNumericProps {
  userAnswer:UserAnswer;
}

@observer
export class RangeSelectorNumeric extends React.Component<IRangeSelectorNumericProps> {
  @observable value: number = 0;
  @observable showNextButton: boolean = false;

  initialize = (props: IRangeSelectorNumericProps) => {
    this.value = props.userAnswer.answerValue ? props.userAnswer.answerValue : props.userAnswer.step.initialNumericValue ? props.userAnswer.step.initialNumericValue : props.userAnswer.step.rangeMin;
  }

  componentWillMount() {
    this.initialize(this.props);
  }

  componentWillReceiveProps(props) {
    this.initialize(props);
  }

  handleChangeComplete() {
    // no reason for this to be wired
  }

  render() {
    const {userAnswer} = this.props;
    const step = userAnswer.step;

    return (
      <QuizQuestion>
        <div className="slider">

          <Range
            min={step.rangeMin}
            max={step.rangeMax}
            step={step.rangeStepValue}
            values={[this.value ]}
            onChange={(v)=>{ this.value = v[0];}}
            onFinalChange={(v)=>{ this.value = v[0]; this.handleChangeComplete(); }}
            renderTrack={({ props, children }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: '6px',
                  width: '100%',
                  backgroundColor: 'rgb(235 235 235)',
                  borderRadius:'3px',
                }}
              >
                {children}
              </div>
            )}
            renderThumb={({ props }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: '30px',
                  width: '30px',
                  backgroundColor: '#FFF',
                  boxShadow:'0 1px 3px rgb(0 0 0 / 40%), 0 -1px 3px rgb(0 0 0 / 40%)',
                  borderRadius:'15px',
                }}
              />
            )}
          />


          <div className="labels">
            <div className="min">{step.rangeMinLabel}</div>
            <div className="max">{step.rangeMaxLabel}</div>
          </div>
          <div className="readout">
            {step.shortName}: {this.value}
          </div>

        </div>
      </QuizQuestion>
    );
  }
}
